import { render, staticRenderFns } from "./newFollowUp.vue?vue&type=template&id=932e9c2e&scoped=true"
import script from "./newFollowUp.vue?vue&type=script&lang=js"
export * from "./newFollowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932e9c2e",
  null
  
)

export default component.exports